//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";
import TabPanel from "../Reusable/Tab";
import EditExpenseNote from "./EditExpenseNote";

const SwitchTab = (props: any) => {
  const {
    handleEdit,
    isLoading,
    data,
    handleMarkAsDone,
    isMarkasDoneloading,
    id,
  } = props;

  return (
    <>
      <TabPanel
        tabTitle={["Update", "Documents"]}
        tabPanels={[
          <>
            <EditExpenseNote
              handleEdit={handleEdit}
              isLoading={isLoading}
              data={data}
              handleMarkAsDone={handleMarkAsDone}
              isMarkasDoneloading={isMarkasDoneloading}
            />
          </>,
          <>
            <FileUpload object_id={id} />
          </>,
        ]}
      />
    </>
  );
};

export default SwitchTab;
